import { ReferralPage } from '@referral/presentation/pages';

import PrivateRoute from '../PrivateRoute';

export function ReferralRoutes() {
  return <PrivateRoute component={ReferralPage} exact path="/referral" />;
}
